import { FormField, FormFieldConfig } from './formField';

/** A form field variant that's intended to never be shown to the user */
export class HiddenFormField<TValue> extends FormField<TValue> {
    public constructor(config?: FormFieldConfig<TValue>) {
        super(config);
        this.hidden = true;
    }
}
